import React from "react";
import styled from "styled-components";

import { mobile, mobileM } from "../../responsive";
import videoOne from "../../video/pexels-cottonbro-8145798_glass_9.45.47.mp4";

//
//
const SectionTop = styled.div`
  width: 100%;
  height: 90vh;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 0 40px 0;
  ${mobile({
    height: "40vh",
  })}
  ${mobileM({
    height: "50vh",
  })}
`;
const Left = styled.div`
  flex: 1;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
`;
const VideoProductContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  //
  //
  .video__product__box {
    width: 100%;
    height: 100%;
    object-fit: cover;
    ${mobileM({
      minHeight: "auto",
    })}
  }
  ${mobileM({
    position: "relative",
    width: "100%",
    height: "100%",
    margin: "0",
    textAlign: "center",
    maxWidth: "1000px",
    overflow: "hidden",
  })}//
  //
`;
//
//

const AllProVideoBanner = () => {
  return (
    <>
      <SectionTop>
        <Left>
          <VideoProductContainer>
            <video autoPlay muted loop className="video__product__box">
              <source src={videoOne} type="video/mp4" />
            </video>
          </VideoProductContainer>
        </Left>
      </SectionTop>
    </>
  );
};

export default AllProVideoBanner;
